import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
type Props = {
  className?: string;
  hrClassName?: string;
};
export default function ArrowRoundtrip(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute right-3 -top-2 translate-x-1/2 translate-y-[-2px] text-inherit"><IoIosArrowForward className="arrow h-4" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute left-3 -bottom-2 -translate-x-1/2 translate-y-[6px] text-inherit"><IoIosArrowBack className="h-4" /></div>;
    t4 = <div className="w-full h-6 rounded-xl border-2 border-solid" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}